import styled from '@emotion/styled'
import { css } from '@emotion/react'

const textShareStyles = ({ theme }) => css`
  label: modal__text-share;

  display: flex;
  align-items: center;

  margin: ${theme.spacings.mega} 0;

  color: ${theme.colors.v500};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};

  span {
    margin-left: ${theme.spacings.byte};
  }

  svg {
    display: block;

    width: 12px;
    height: 12px;
  }
`

const descriptionStyles = ({ theme, heading }) => css`
  label: modal__info-description;

  display: block;

  color: ${heading ? theme.colors.black : theme.colors.n500};
  font-size: 13px;
  font-weight: ${heading ? theme.font.weight.semibold : theme.font.weight.regular};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  &:not(:last-child) {
    margin-bottom: ${heading
      ? `${theme.spacings.byte}`
      : `${theme.spacings.mega}`};
  }
`

const productLinkStyles = ({ theme }) => css`
  label: modal__info-product-link;

  display: flex;

  align-items: center;

  font-size: 13px;
  line-height: ${theme.typography.subHeadings.mega.lineHeight};
  margin-bottom: ${theme.spacings.tera};
  color: ${theme.colors.p500};

  i {
    margin-top: 1px;
    margin-left: ${theme.spacings.bit};
  }
`

export const TextShare = styled('span')(textShareStyles)
export const Description = styled('span')(descriptionStyles)
export const ProductLink = styled('a')(productLinkStyles)
